import { render, staticRenderFns } from "./QuizHost.vue?vue&type=template&id=07d63113&scoped=true&"
import script from "./QuizHost.vue?vue&type=script&lang=js&"
export * from "./QuizHost.vue?vue&type=script&lang=js&"
import style0 from "./QuizHost.vue?vue&type=style&index=0&id=07d63113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d63113",
  null
  
)

export default component.exports